import { BreakpointService } from './BreakpointService';

export default new BreakpointService();
export * from './BreakpointService';
